import { OrderStatus } from '@notify/shared';

import { api } from './api';

export interface OrderValidation {
  orderId: string;
  orderReference: string;
  status: OrderStatus;
  prepDeadline: string | null;
  shopName: string;
}

export interface BrowserPushSubscription {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
}

export interface OrderStatusResult {
  status: OrderStatus;
  prepDeadline: string | null;
  notifiedAt: string | null;
}

export const checkinService = {
  validateOrder(shopId: string, orderReference: string): Promise<OrderValidation> {
    return api.get<OrderValidation>(
      `/api/v1/notifications/validate/${shopId}/${orderReference}`
    );
  },

  async getVapidKey(): Promise<string> {
    const result = await api.get<{ vapidPublicKey: string }>('/api/v1/notifications/vapid-key');
    return result.vapidPublicKey;
  },

  subscribe(
    orderId: string,
    subscription: BrowserPushSubscription
  ): Promise<{ message: string }> {
    return api.post<{ message: string }>('/api/v1/notifications/subscribe', {
      orderId,
      subscription,
    });
  },

  getOrderStatus(orderId: string): Promise<OrderStatusResult> {
    return api.get<OrderStatusResult>(`/api/v1/notifications/status/${orderId}`);
  },

  getShopPublicInfo(shopId: string): Promise<{ shopName: string; location: string }> {
    return api.get<{ shopName: string; location: string }>(`/api/v1/shops/public/${shopId}`);
  },
};
